import React from "react";
import { useQuery } from "@tanstack/react-query";
import { GridCol } from "@design-system/Grid/GridCol";
import { GridRow } from "@design-system/Grid/GridRow";
import { getSimulationsDashboard } from "@lib/simulations";
import { Loader } from "@design-system/Loader/Loader";
import { RecentMessages } from "./RecentMessages";
import { SimulatePlaidAccountError } from "./SimlulatePlaidAccountError";
import { SimulateIncomingSms } from "./SimulateIncomingSms";
import { ExternalConnections } from "./ExternalConnections";

export const SimulationsDashboard: React.FC = () => {
    const { data: dashboard } = useQuery({
        queryKey: ["simulationsDashboard"],
        queryFn: getSimulationsDashboard,
    });

    return dashboard ? (
        <main className="pt-5 pl-5 pr-5 pb-5">
            <div className="mb-4">
                <RecentMessages messages={dashboard.recentMessages} />
            </div>

            <div className="mb-4">
                <ExternalConnections connections={dashboard.plaidConnections} />
            </div>

            <GridRow>
                <GridCol sm={3}>
                    <SimulatePlaidAccountError />
                </GridCol>
                <GridCol sm={3}>
                    <SimulateIncomingSms />
                </GridCol>
            </GridRow>
        </main>
    ) : (
        <Loader />
    );
};
